import { render, staticRenderFns } from "./InfoItem.vue?vue&type=template&id=65fd19a3&scoped=true"
import script from "./InfoItem.vue?vue&type=script&lang=js"
export * from "./InfoItem.vue?vue&type=script&lang=js"
import style0 from "./InfoItem.vue?vue&type=style&index=0&id=65fd19a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fd19a3",
  null
  
)

export default component.exports